import { React, useState } from "react";
import { ChapterWrapper } from "../Education.styled";
import PropTypes from "prop-types";
import { formatDuration } from "../utils";

function Chapters({ type, data }) {

    // console.log(data.chapter)
	// eslint-disable-next-line no-unused-vars
	const [displayVideo, setdisplayVideo] = useState(false);
	const [url, setUrl] = useState("");
	const PlayButton = () => {
		switch (type) {
			case "audio":
				return <button onClick={playVideo} type='button'> Play Audio</button>;
			case "video":
				return (
					<button onClick={playVideo} type='button'>
						Play Video
					</button>
				);
			// case "book":
			// 	return <button type='button'> Read Book</button>;
			default:
				return <button type='button'> Play</button>;
		}
	};

	const playVideo = () => {
		setdisplayVideo(true);
        setUrl(data?.link)
	};

	return (
		<ChapterWrapper>
			{!displayVideo ? (
				<>
					<img src= { data?.coverPhoto || "/images/placeholder_img.jpg" } alt='content thumbnail' />
					<main>
						<div>
							{/* <p className='chapter_text'>Chapter 1</p> */}
                            {data?.chapter ?  <p className='chapter_text'>chapter {data?.chapter}</p> : <p className='chapter_text'>Single chapter</p> }
							<PlayButton />
						</div>

						<div>
							<p className='content_title'>{data?.name}</p>
							<p> {data?.chapter ?  formatDuration(data?.duration) : data?.totalDuration}</p>
						</div>
					</main>
				</>
			) : null}

			{displayVideo ? (
				<video
					style={{ borderRadius: "1rem" }}
					autoPlay={true}
					controls
					disablePictureInPicture
					playsInline
					src={url}
					width={"100%"}
					height={type === 'video' ? '200' : '80'}
				>
					<p>
						Your browser doesnt support HTML {type === 'video' ? 'Video' : 'Audio'}. Here is a
						<a href={url}>link to the video</a> instead.
					</p>
				</video>
			) : null}
		</ChapterWrapper>
	);
}

Chapters.propTypes = {
	type: PropTypes.string,
    data: PropTypes.object
};
export default Chapters;
